import { AppActionType } from '../appContext/actions';
import { useAppContext } from '../appContext/context';

interface UseUpgradeDialogVisibilityResponse {
  visible: boolean;
  setDialogVisibility: (visible: boolean) => void;
}

export const useUpgradeDialogVisibility = (): UseUpgradeDialogVisibilityResponse => {
  const { appState, appDispatch } = useAppContext();

  const setDialogVisibility = (visible: boolean) => {
    appDispatch({
      type: AppActionType.SET_UPGRADE_DIALOG_VISIBLE,
      payload: visible,
    });
  };

  return {
    visible: appState.upgradeDialogVisible,
    setDialogVisibility,
  };
};
